import { render, staticRenderFns } from "./COAAddSubTaxAccountModal3.vue?vue&type=template&id=b4718400&scoped=true&"
import script from "./COAAddSubTaxAccountModal3.vue?vue&type=script&lang=js&"
export * from "./COAAddSubTaxAccountModal3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4718400",
  null
  
)

export default component.exports